import { ListItemIcon, MenuItem, alpha, styled } from '@mui/material';
import { NAV } from 'src/config-global';
import { pxToRem } from 'src/theme/typography';

export const StyledIcon = styled(ListItemIcon)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 'unset !important',
  marginRight: theme.spacing(0.5),
  '&.hidden': {
    '.navIcon': {
      color: 'transparent',
    },
  },
  '&:hover:not(.hidden)': {
    '.navIcon': {
      color: theme.palette.text.primary,
    },
  },
}));

export const MenuItemStyled = styled(MenuItem, {
  shouldForwardProp(propName) {
    return !['depth', 'disabled', 'active', 'lastItem', 'isButton'].includes(
      propName as any,
    );
  },
})<{
  depth: number;
  disabled?: boolean;
  active?: boolean;
}>(({ theme, depth }) => ({
  width: '100%',
  position: 'relative',
  textTransform: 'capitalize',
  display: 'flex',
  alignItems: 'center',
  height: NAV.H_DASHBOARD_ITEM_HORIZONTAL,
  paddingLeft: theme.spacing(2.75),
  paddingRight: theme.spacing(0.5),
  paddingTop: theme.spacing(0.25),
  paddingBottom: theme.spacing(0.25),
  borderRadius: theme.shape.borderRadius,
  color: theme.palette.text.secondary,
  '&.isTreeView': {
    paddingLeft: theme.spacing(1),
  },

  ...(depth > 1 && {
    paddingLeft: theme.spacing(depth),
  }),

  '& .MuiListItemText-root': {
    overflow: 'hidden',
    marginLeft: theme.spacing(0),
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.complex,
    }),
  },
  '&.Mui-disabled': {
    opacity: 0.64,
  },
  '&.selected': {
    color: theme.palette.primary.main,
  },
  '&.connected': {
    color: theme.palette.success.main,
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  '&.Mui-selected': {
    color: theme.palette.primary.main,
    backgroundColor: alpha(
      theme.palette.primary.main,
      theme.palette.action.selectedOpacity,
    ),
    '&:hover:not(.connected)': {
      backgroundColor: alpha(
        theme.palette.primary.main,
        theme.palette.action.selectedOpacity,
      ),
    },
    '&.connected': {
      color: theme.palette.success.main,
      backgroundColor: 'transparent',
    },
  },
  '&.isSubActive': {
    color: theme.palette.text.secondary,
    backgroundColor: 'transparent',
  },
  '.highlight': {
    color: theme.palette.common.white,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: theme.spacing(2.5),
    height: theme.spacing(2.5),
    borderRadius: theme.spacing(1.25),
    backgroundColor: theme.palette.error.main,
    flexShrink: 0,
    fontSize: pxToRem(10),
    fontWeight: theme.typography.fontWeightMedium,
    padding: theme.spacing(0, 0.5),
    marginLeft: theme.spacing(1),
  },
  '&.iconOnly': {
    padding: theme.spacing(1),
    flexDirection: 'column',
    '& .MuiListItemText-root': {
      width: '1px',
    },
  },
  '.hoverOnly:not(.active)': {
    visibility: 'hidden',
    width: '0px',
  },
  '&:hover': {
    '.hoverOnly': {
      visibility: 'visible',
      width: 'unset',
      '&.MuiIconButton-root': {
        marginLeft: theme.spacing(0.5),
      },
    },
  },
}));
